import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {ScheduleCostAvoidance} from '../api'
import {getCostAvoidanceDailyPath} from '../api/schedule.endpoints'

export const COST_AVOIDANCE_DAILY_QUERY_KEY = 'costAvoidanceDaily'

export const costAvoidanceDailyQueryOptions = (
  plantId: string,
  fromDay: string,
  toDay: string
) => ({
  queryKey: [COST_AVOIDANCE_DAILY_QUERY_KEY, {plantCode: plantId, fromDay, toDay}] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<ScheduleCostAvoidance[]>(
      getCostAvoidanceDailyPath(plantId),
      {
        params: {from: fromDay, to: toDay},
        signal
      }
    )

    return response.data
  }
})

interface UseCostAvoidanceDailyQueryParams {
  plantId: string
  fromDay: string
  toDay: string
  enabled?: boolean
  throwOnError?: boolean
}

export const useCostAvoidanceDailyQuery = ({
  plantId,
  fromDay,
  toDay,
  enabled = true,
  throwOnError = true
}: UseCostAvoidanceDailyQueryParams) => {
  return useQuery<ScheduleCostAvoidance[], AxiosError>({
    ...costAvoidanceDailyQueryOptions(plantId, fromDay, toDay),
    enabled,
    throwOnError,
    ...(enabled ? {} : {gcTime: 0})
  })
}
